export default "__VITE_ASSET__CfVXBt85__"